export const DEFAULT_REMINDER_WEEKS_BEFORE = 4
export const MAX_REMINDER_WEEKS_BEFORE = 52

export function parseReminderWeeks(value: string): number | null {
  if (!/^\d+$/.test(value.trim())) return null

  const weeks = Number(value)
  return weeks >= 1 && weeks <= MAX_REMINDER_WEEKS_BEFORE ? weeks : null
}
